import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import { getTPAID } from '@/store/global_helpers/sessionReturn.js';

const state = {
    siteAdmin: {
        BrokerList: [],
    },
};

const getters = {
    getSiteAdminBrokerList: (state) => state.siteAdmin.BrokerList,
};

const actions = {
    async adminCreateBroker({dispatch}, broker){
        let authHeader = getAuthHeader();
        axios.post("/broker/", {broker:broker}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully created ${broker.broker_dealer_name}.`, {root: true});
            dispatch('adminGetBrokerList');
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error creating ${broker.broker_dealer_name}!`, {root: true});
        });
    },
    
    async adminUpdateBroker({dispatch}, broker){
        let authHeader = getAuthHeader();
        axios.put("/broker/", {broker:broker}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully updated ${broker.broker_dealer_name}!`, {root: true});
            dispatch('adminGetBrokerList');
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error updating ${broker.broker_dealer_name}!`, {root: true});
        });
    },

    async adminGetBrokerList({commit, dispatch}){
        let tpa_id = getTPAID();
        let authHeader = getAuthHeader();
        axios.get("/broker/list/?tpa_id="+tpa_id, authHeader)   
        .then((res) => {
            commit('adminSetBrokerList', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error loading the Broker list!', {root: true});
        });
    }
};

const mutations = {
    adminSetBrokerList(state, list){
        let filtered = list.filter(broker => broker.broker_dealer_name !== "No Broker Dealer")
        filtered.sort((a,b) => a.broker_dealer_name.toLowerCase() > b.broker_dealer_name.toLowerCase());
        state.siteAdmin.BrokerList = filtered;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};